<template>
  <w-setting-sliding-popup ref="slidingPopup" title="과점유 예외 프로세스 등록" @close="closePopup">
    <el-form slot="content" :model="exceptInfo" :rules="rules" label-position="top" ref="exceptInfoForm">
      <el-row v-if="isAdd">
        <el-col :span="24">
          <el-row class="title-bar" type="flex" justify="end">
            <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
          </el-row>
          <el-table-wrapper @selection-change="procChangeSelection" :data="dataList" :columns="occupyColumns" :column-default="columnDefault" :pagination="false" :show-custom-header="true" :show-search-tool="showSearchTool" style="width:100%;">
          </el-table-wrapper>
        </el-col>
      </el-row>
      <el-row v-else>
        <el-col :span="24">
          <el-form-item label="프로세스명" prop="processName">
            <el-input :disabled='editField' v-model="exceptInfo.processName" placeholder="입력해 주세요."></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="예외 사유" prop="processDesc">
            <el-input v-model="exceptInfo.processDesc" placeholder="입력해 주세요."></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="예외 시작 시간" prop="startTime">
            <el-time-picker v-model="exceptInfo.startTime" format= 'HH:mm' :editable= "false" :picker-options="{format: 'HH:mm'}" placeholder="시작시간">
            </el-time-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="예외 종료 시간" prop="endTime">
            <el-time-picker v-model="exceptInfo.endTime" format= 'HH:mm' :editable= "false" :picker-options="{format: 'HH:mm'}" placeholder="종료시간">
            </el-time-picker>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row slot="footer" type="flex" justify="center">
      <el-button size="large" type="solid" class="mr-r4" @click="saveExceptOccupy">저장</el-button>
      <el-button size="large" @click="closePopup">취소</el-button>
    </el-row>
  </w-setting-sliding-popup>
</template>

<script>
import { forEach, isNil, isUndefined, clone } from 'lodash';
import { columnDefault } from '@/constants/table';
import msgUtil from '@/utils/message';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import ServerSettingAPI from '@/api/settings/server/server-settings';

export default {
  name: 'WExceptOccupyListPopup',
  props: {
    popupParam: Object,
    popupType: String,
    editRow: Object,
  },
  watch: {
    editRow: {
      handler(row) {
        this.exceptInfo = clone(row);
        if (this.popupType === 'ADD') {
          this.params.objId = this.popupParam.objId;
          this.loadProcList();
          this.isAdd = true;
          this.editField = false;
        } else {
          this.isAdd = false;
          this.editField = true;
          this.exceptInfo.startTime = this.convertDatetime(this.exceptInfo.startTime);
          this.exceptInfo.endTime = this.convertDatetime(this.exceptInfo.endTime);
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      formName: 'exceptInfoForm',
      changeProcList: [],
      showSearchTool: false,
      dataList: null,
      editField: false,
      isAdd: false,
      params: {
        objId: null,
      },
      exceptInfo: {
        processName: null,
        processDesc: null,
        startTime: null,
        endTime: null,
      },
      columnDefault,
      occupyColumns: [
        {
          align: 'center',
          type: 'selection',
        },
        {
          prop: 'procPid',
          label: 'PID',
          width: 100,
          sortable: true,
          searchable: false,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'procName',
          label: '프로세스 명',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
      ],
      rules: {
        processDesc: [
          {
            required: true,
            trigger: 'blur',
            validator: this.validateNull,
            message: '필수 정보입니다.',
          },
        ],
        startTime: [
          {
            required: true,
            trigger: 'blur',
            validator: this.validateNull,
            message: '필수 정보입니다.',
          },
        ],
        endTime: [
          {
            required: true,
            trigger: 'blur',
            validator: this.validateNull,
            message: '필수 정보입니다.',
          },
        ],
      },
    };
  },
  methods: {
    loadProcList() {
      ServerSettingAPI.getProcessList(this.params).then((response) => {
        if (response.data.success) {
          this.dataList = response.data.data;
        }
      });
    },
    saveExceptOccupy() {
      const saveParams = [];
      const me = this;
      const target = '과점유 예외 프로세스';
      this.$refs[this.formName].validate((valid) => {
        if (valid) {
          if (this.popupType === 'ADD') {
            forEach(me.changeProcList, (item) => {
              saveParams.push({
                processName: item.procName,
                serverId: me.popupParam.serverId,
                processDesc: me.exceptInfo.processDesc,
                startTime: me.exceptInfo.startTime,
                endTime: me.exceptInfo.endTime,
              });
            });
            ServerSettingAPI.insertExceptProcess(saveParams).then((response) => {
              if (response.data.success) {
                this.$message(msgUtil.getResultMsgData(msgUtil.action.SAVE, target, true));
                this.$emit('reload-data');
                this.closePopup();
              }
            });
          } else {
            ServerSettingAPI.updateExceptProcess(this.exceptInfo).then((response) => {
              if (response.data.success) {
                this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, target, true));
                this.$emit('reload-data');
                me.closePopup();
              }
            });
          }
        } else {
          this.$message(msgUtil.getCustomMsgData('필수사항을 입력해주세요.'));
        }
      });
    },
    closePopup() {
      this.dataList = null;
      this.$refs[this.formName].resetFields();
      this.$refs.slidingPopup.visible = false;
    },
    open() {
      this.$refs.slidingPopup.open();
      this.$emit('open');
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    convertDatetime(value) {
      if (isNil(value)) {
        return EMPTY_TEXT;
      }
      return new Date(value);
    },
    procChangeSelection(selectVal) {
      this.changeProcList = selectVal;
    },
    validateNull(rule, value, callback) {
      if (isUndefined(value) || value === '' || isNil(value)) {
        callback(new Error());
      } else {
        callback();
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/server/ProcessSettings/OligopolisticProcessSettingView/popup/ExceptOccupyListPopup.vue